import { Store } from "@app/interface/Stores";
import { formatTime } from "@app/utils/formatTime";
import * as React from "react";
import IconFisAvailable from "../Icons/FisAvailable";
import IconFisLow from "../Icons/FisLow";
import IconCFisOos from "../Icons/FisOos";

type Props = {
  selectedVariant: string | undefined;
  handleClick?: (storeId: string) => void;
  selectedStore: string;
  store: {
    store: Store;
    distance: number | null;
    id: string;
    handle: string;
    stock: Array<{
      level: number;
      sku: string;
    }>;
  };
};

const ProductStockDrawerStore: React.FC<Props> = ({ store, selectedStore, selectedVariant, handleClick }) => {
  const selected = store.id === selectedStore;

  const openHours = store.store.open_hours ? JSON.parse(store.store.open_hours) : null;

  const renderStockAvailability = () => {
    const stock = store.stock.find(({ sku }) => sku === selectedVariant);
    const level = stock?.level ?? 0;

    if (level > 3) {
      return (
        <div className="find-in-store__drawer--stock available">
          <IconFisAvailable />
          <p>Available</p>
        </div>
      );
    } else if (level >= 2) {
      return (
        <div className="find-in-store__drawer--stock available">
          <IconFisLow />
          <p>Limited</p>
        </div>
      );
    } else {
      return (
        <div className="find-in-store__drawer--stock oos">
          <IconCFisOos />
          <p>Call Store</p>
        </div>
      );
    }
  };

  return (
    <button
      className={`find-in-store__drawer--store ${selected ? "selected" : ""}`}
      onClick={() => handleClick?.(store.id)}
    >
      <div className="find-in-store__drawer--store-content">
        <div className="">
          <p className="store-name">{store.store.name}</p>
          {store.store.address_text && store.store.address_text.trim().toLowerCase() !== "null" && (
            <p className="store-address">{store.store.address_text}</p>
          )}
          {store.distance && <p className="store-distance">{store.distance}Km</p>}
          {selected && (
            <div className="store-hours">
              {store.store.phone && <p className="store-phone">{store.store.phone}</p>}
              {openHours.length > 0 && (
                <div className="store-hours__content">
                  <p>Store Hours</p>
                  {openHours.map((dayObj, i) => {
                    const [day, hoursArray] = Object.entries(dayObj)[0]; // Get the day and its hours
                    const { open, close, storeClosed } = hoursArray[0];
                    return (
                      <div key={i} className="store-hours__content--item">
                        <p>{day}:</p>
                        <p>{storeClosed ? "Closed" : `${formatTime(open)} - ${formatTime(close)}`}</p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>

        {renderStockAvailability()}
      </div>

      {selected && store.store.phone && (
        <a className="store-call-btn" href={`tel:${store.store.phone}`}>
          Call the Store
        </a>
      )}
    </button>
  );
};

export { ProductStockDrawerStore };
